document.addEventListener('DOMContentLoaded', () => {
  const occupancyMap = {
    S1: 0.10,
    S2: 0.20,
    S3: 0.40,
    S4: 0.60,
    S5: 0.80
  };

  const jsonUrl = window.CalcolatoreFatturatoDataUrl || '/assets/calcolatore-fatturato.json';

  const section = document.getElementById('calcolatore-fatturato-section');
  if (!section) return;

  const form = section.querySelector('#calcolatore-fatturato-form');
  const provinciaSelect = section.querySelector('#provincia');
  const comuneSelect = section.querySelector('#comune');
  const resultBox = section.querySelector('#calcolatore-fatturato-result');

  let dataset = [];

  const formatEUR = (value) =>
    new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0
    }).format(value);

  const normalize = (str) =>
    (str || '')
      .toString()
      .trim()
      .toUpperCase()
      .replace(/\s+/g, ' ')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const getSelectedStaff = () => {
    const checked = form.querySelector('input[name="staff"]:checked');
    return checked ? checked.value : '';
  };

  const uniqueProvinces = () => {
    const map = new Map();
    dataset.forEach((row) => {
      const key = normalize(row.provincia);
      if (key && !map.has(key)) map.set(key, row.provincia);
    });
    return [...map.values()].sort((a, b) => a.localeCompare(b, 'it'));
  };

  const populateProvince = () => {
    const provinces = uniqueProvinces();
    provinciaSelect.innerHTML = '<option value="">Seleziona Provincia</option>';
    provinces.forEach((provincia) => {
      const opt = document.createElement('option');
      opt.value = provincia;
      opt.textContent = provincia;
      provinciaSelect.appendChild(opt);
    });
  };

  const populateComuni = (provinciaValue) => {
    const normalizedProvincia = normalize(provinciaValue);
    const comuni = dataset
      .filter((row) => normalize(row.provincia) === normalizedProvincia)
      .map((row) => row.comune)
      .filter(Boolean)
      .sort((a, b) => a.localeCompare(b, 'it'));

    comuneSelect.innerHTML = '<option value="">Seleziona Comune</option>';
    comuni.forEach((comune) => {
      const opt = document.createElement('option');
      opt.value = comune;
      opt.textContent = comune;
      comuneSelect.appendChild(opt);
    });

    comuneSelect.disabled = comuni.length === 0;
  };

  const loadData = async () => {
    try {
      const res = await fetch(jsonUrl, { cache: 'no-store' });
      dataset = await res.json();
      populateProvince();
    } catch (e) {
      resultBox.innerHTML = '<p>Impossibile caricare i dati dei comuni.</p>';
    }
  };

  provinciaSelect.addEventListener('change', (e) => {
    populateComuni(e.target.value);
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const provincia = provinciaSelect.value;
    const comune = comuneSelect.value;
    const giorni = parseFloat(section.querySelector('#giorni').value);
    const capienzaMin = parseFloat(section.querySelector('#capienza_min').value);
    const capienzaMax = parseFloat(section.querySelector('#capienza_max').value);
    const prezzo = parseFloat(section.querySelector('#prezzo').value);
    const staff = getSelectedStaff();

    if (!provincia || !comune || !giorni || !capienzaMin || !capienzaMax || !prezzo || !staff) {
      resultBox.innerHTML = '<p>Compila tutti i campi prima di calcolare.</p>';
      return;
    }

    if (capienzaMax < capienzaMin) {
      resultBox.innerHTML = '<p>La capienza massima deve essere uguale o superiore alla capienza minima.</p>';
      return;
    }

    const row = dataset.find(
      (item) =>
        normalize(item.provincia) === normalize(provincia) &&
        normalize(item.comune) === normalize(comune)
    );

    if (!row) {
      resultBox.innerHTML = '<p>Comune non trovato nel database.</p>';
      return;
    }

    const sintesi = normalize(row.sintesi);
    const occupancyRate = occupancyMap[sintesi] || 0.10;
    const capienzaMedia = (capienzaMin + capienzaMax) / 2;
    const staffFactor = staff === 'si' ? 1.2 : 1.0;

    const base = prezzo * capienzaMedia * 3 * occupancyRate * giorni * 52 * staffFactor;
    const minimo = base * 0.85;
    const massimo = base * 1.15;

    resultBox.innerHTML = `
      <p><strong>Comune selezionato:</strong> ${comune}</p>
      <p><strong>Classe turistica:</strong> ${sintesi}</p>
      <p><strong>Fatturato annuo stimato:</strong> ${formatEUR(base)}</p>
      <p><strong>Fatturato annuo minimo:</strong> ${formatEUR(minimo)}</p>
      <p><strong>Fatturato annuo massimo:</strong> ${formatEUR(massimo)}</p>
    `;
  });

  loadData();
});